(function () {
  "use strict";
  const MAX_FILE_SIZE = 1024 * 1024 * 10;
  const section = document.querySelector("#warrantyFormSection");
  const sectionId = section.dataset.sectionId;
  const successScreen = section.querySelector(".success-screen");
  const newClaimBtn = successScreen.querySelector("button");
  const formScreen = section.querySelector(".form-screen");
  const form = document.querySelector("#warranty-" + sectionId);
  const progressBar = form.querySelector(
    "#WarrantyFormProgressBar-" + sectionId,
  );
  const submitBtn = form.querySelector("#warranty-form-submit-" + sectionId);
  const formErrorsEl = form.querySelector(".form-error");
  const inputs = Array.from(form.querySelectorAll(".input-full")).reduce(
    (a, cv) => ({ ...a, [cv.name]: { el: cv, error: false } }),
    {},
  );
  const schema = {
    order_number: {
      required: true,
      message: "Order number is required",
      type: "string",
    },
    name: {
      required: true,
      message: "Your name is required",
      type: "string",
    },
    email: { required: true, message: "Email is required", type: "string" },
    phone: {
      required: true,
      message: "Phone number is required",
      type: "string",
    },
    warranty_issue: {
      required: true,
      message: "Warranty issue is required",
      type: "string",
    },
    is_firefighter: {
      required: false,
      type: "string",
    },
    media: {
      required: true,
      message:
        "We require you to provide pictures and/or video of the issue. This helps us determine the nature of the issue.",
      type: "file",
    },
  };

  newClaimBtn.addEventListener("click", () => {
    successScreen.classList.add("hide");
    formScreen.classList.remove("hide");
    focusElement(formScreen.querySelector(".section-header__title"));
  });

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    document.querySelector(".note--success")?.remove();

    const formData = new FormData(form);
    if (!validateForm(formData)) {
      focusFirstInvalid();
      return;
    }

    try {
      submitBtn.classList.add("btn--loading");
      progressBar.classList.remove("hide");
      const response = await fetchProgress(`${theme.routes.app}/warranty`, {
        method: "POST",
        body: formData,
        progress: (evt) => {
          var percent = Math.round((evt.loaded / evt.total) * 100);
          progressBar.value = percent;
        },
      });
      const body = await response.json();
      // console.log(body);
      if (response.status !== 200) {
        if (body.error?.fieldErrors) {
          svValidation(body.error.fieldErrors);
          focusFirstInvalid();
          return;
        } else {
          throw new Error(response.statusText);
        }
      }
      resetForm();
      formScreen.classList.add("hide");
      successScreen.classList.remove("hide");
      focusElement(successScreen.querySelector(".success-message h3"));
    } catch (error) {
      // console.log(error);
      formErrorsEl.innerHTML =
        "<ul><li>Error submitting warranty, please try again</li></ul>";
      formErrorsEl.classList.remove("hide");
      formErrorsEl.focus();
    } finally {
      submitBtn.classList.remove("btn--loading");
    }
  });

  function fetchProgress(action, options = {}) {
    const xhr = new XMLHttpRequest();
    return new Promise((success, failure) => {
      options.progress &&
        xhr.upload.addEventListener("progress", options.progress);

      xhr.onreadystatechange = function () {
        if (xhr.readyState != 4) {
          return;
        }
        var response = new Response(xhr.response, {
          url: xhr.responseURL,
          status: xhr.status,
          statusText: xhr.statusText,
        });
        success(response);
      };

      xhr.addEventListener("error", () => {
        failure(new TypeError("Failed to fetch"));
      });

      xhr.open(options.method ?? "GET", action);
      xhr.send(options.body ?? null);
    });
  }

  function svValidation(errors) {
    for (const [key, message] of Object.entries(errors)) {
      const input = inputs[key];
      input.error = true;
      input.el.classList.add("input-error");
      input.el.nextElementSibling.innerText = message;
      setFieldInvalid(input.el, true);
    }
  }

  function setFieldInvalid(el, invalid) {
    if (invalid) {
      const errorEl = el.nextElementSibling;
      errorEl.id = errorEl.id || el.id + "-error";
      el.setAttribute("aria-invalid", "true");
      el.setAttribute("aria-describedby", errorEl.id);
    } else {
      el.removeAttribute("aria-invalid");
      el.removeAttribute("aria-describedby");
    }
  }

  function focusFirstInvalid() {
    form.querySelector('[aria-invalid="true"]')?.focus();
  }

  function focusElement(el) {
    el.setAttribute("tabindex", "-1");
    el.focus();
  }

  function validateForm(formData) {
    let valid = true;
    let fileValid = true;
    for (const pair of formData.entries()) {
      let fieldValid = true,
        message = "",
        value = pair[1],
        fieldSchema = schema[pair[0]],
        input = inputs[pair[0]];

      if (fieldSchema.type === "file" && !fileValid) continue;

      if (fieldSchema.required) {
        fieldValid =
          fieldSchema.type === "string"
            ? value && value.trim() !== ""
            : fieldSchema.type === "file"
              ? value && value.name !== "" && value.size > 0
              : value !== null && value !== undefined;
        message = fieldSchema.message;
      }

      if (fieldValid && fieldSchema.type === "file") {
        if (input.el.files.length > 10) {
          fileValid = fieldValid = false;
          message = "There is an upload limit of 10 files";
        } else if (
          fieldValid &&
          !(value.type.startsWith("image/") || value.type.startsWith("video/"))
        ) {
          fileValid = fieldValid = false;
          message = "Only image and video file formats are supported";
        } else if (fieldValid && value.size > MAX_FILE_SIZE) {
          fileValid = fieldValid = false;
          message = "Max file size is 10MB";
        }
      }

      if (fieldValid && input.error) {
        input.el.classList.remove("input-error");
        input.el.nextElementSibling.innerHTML = "";
        input.error = false;
        setFieldInvalid(input.el, false);
      } else if (!fieldValid) {
        input.error = true;
        input.el.classList.add("input-error");
        input.el.nextElementSibling.innerText = message;
        setFieldInvalid(input.el, true);
      }

      valid = !fieldValid ? false : valid;
    }
    return valid;
  }

  function resetForm() {
    form.reset();
    formErrorsEl.innerHTML = "";
    formErrorsEl.classList.add("hide");
    progressBar.classList.add("hide");
    progressBar.value = 0;
  }
})();
